import { api } from "api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { T_Api_Paginated } from "./api.types";
import { T_AffiliatePlan } from "dtos/affiliate.plan.dto";

export const affiliatePlanService = {
  useGetAllPaginated: ({ page, limit }: { page: number; limit: number }) => {
    return useQuery({
      queryKey: ["affiliate-plan/all", page, limit],
      queryFn: async () => {
        const res = await api.get(`/affiliate-plan?page=${page}&limit=${limit}`);
        return res.data?.result as T_Api_Paginated<T_AffiliatePlan>;
      },
    });
  },
  useAddAffiliatePlan: () => {
    return useMutation({
      mutationKey: ["affiliate-plan/create"],
      mutationFn: async (body: T_AffiliatePlan) => {
        return api.post("/affiliate-plan/create", body);
      },
    });
  },
  useGetById: (id: string | undefined) => {
    return useQuery({
      queryKey: ["affiliate-plan", id],
      queryFn: async () => {
        const res = await api.get(`/affiliate-plan/${id}`);
        return res.data?.result.data as T_AffiliatePlan;
      },
      enabled: !!id,
    });
  },
  useUpdateAffiliatePlan: () => {
    return useMutation({
      mutationKey: ["affiliate-plan/update"],
      mutationFn: async ({ id, body }: { id: string; body: Partial<T_AffiliatePlan> }) => {
        return api.put(`/affiliate-plan/update/${id}`, body);
      },
    });
  },
  useDeleteById: () => {
    return useMutation({
      mutationKey: ["delete"],
      mutationFn: async (id: string) => {
        return api.delete(`/affiliate-plan/remove/${id}`);
      },
    });
  },

  useAssignAffiliatePlan: () => {
    return useMutation({
      mutationKey: ["user", "assign/affiliate-plan"],
      mutationFn: async (body: { user_id: string; plan_id: string }) => {
        const res = await api.patch(`/affiliate-plan/user/assign`, body);
        return res.data;
      },
    });
  },
};
